/*
 *
 * @desc: 产品页Care服务加购
 * @author: haifn
 * @time: 2021/4/26 12:04 下午
 *
 */
import { CountryCode } from '@/utils';

const enabledCountryMap = [
  'US',
  'CN',
  'HK',
  'JP',
  'DE',
  'AT',
  'BE',
  'BG',
  'DK',
  'EE',
  'FI',
  'GR',
  'IE',
  'HR',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SE',
  'SK',
  'SI',
  'CZ',
  'HU',
  'CY',
  'FR',
  'IT',
  'ES',
  'KR',
  'MY',
  'TH',
  'SG',
  'TW',
  'KR',
  'PH',
  'AU',
  'AE',
  'NZ',
  'BN',
  'GB',
  'CA',
  'ID',
  'MX',
  'MO',
  'VN',
  'LI',
  'CH',
];

const enabledCountry = enabledCountryMap.includes(CountryCode);

// const Data = {
//   go3: {
//     cid: 2346,
//     enabled: true,
//     defaultUnSelect: true,
//     relatedCommodity: [
//       {
//         name: 'go3',
//         desc: 'go3',
//         pid: 24,
//         enabled: true,
//         cids: [
//           2376, 2378, 2379, 2380, 2381, 2382, 2383, 2384, 2385, 2386, 2387, 2388, 2389, 2390, 2391, 2392, 2393, 2394,
//           2395, 2396, 2397, 2398, 2399, 2400, 2382, 2389, 2396, 2798, 2799, 2800, 2801, 2802, 2803, 2804, 2805, 2806,
//           2807, 2808, 2809, 2810, 2811, 2841, 3282, 3283, 3327, 3328,
//         ],
//       },
//     ],
//   },
//   ONE_X2: {
//     cid: 1470,
//     enabled: true,
//     defaultUnSelect: true,
//     relatedCommodity: [
//       {
//         name: 'ONE_X2',
//         desc: 'ONE X2',
//         pid: 13,
//         enabled: true,
//         cids: [
//           1961, 1966, 1164, 1180, 1176, 2185, 1179, 1181, 1182, 1516, 1517, 1499, 1501, 1316, 1832, 1838, 2339, 2598,
//           2881, 2884,
//         ],
//       },
//       {
//         name: 'Proptech-Labs-Virtual-Tour-Bundle',
//         desc: 'Proptech-Labs-Virtual-Tour-Bundle',
//         pid: 617,
//         enabled: true,
//         cids: [3689],
//       },
//       {
//         name: 'ONE_X2_Virtual_Tour',
//         desc: 'ONE X2 海外房产',
//         pid: 21,
//         enabled: true,
//         cids: [1454, 1455, 2565, 2566, 2567, 2568, 2569, 2570, 2571, 2572, 2573, 2574, 2575, 2576, 2837],
//       },
//       {
//         name: 'real_estate_kit',
//         desc: '大陆房产套餐',
//         pid: 225,
//         enabled: true,
//         cids: [2901, 2902],
//       },
//     ],
//   },
//   GO_2: {
//     cid: 1468,
//     enabled: true,
//     defaultUnSelect: true,
//     relatedCommodity: [
//       {
//         name: 'GO_2',
//         desc: 'GO 2',
//         pid: 14,
//         enabled: true,
//         cids: [
//           1324, 1582, 1539, 1587, 1346, 1583, 1345, 1584, 1325, 1585, 1523, 1586, 1632, 1635, 1767, 1768, 1824, 1825,
//           2027, 2028, 2341,
//         ],
//       },
//     ],
//   },
//   ONE_RS: {
//     cid: 1757,
//     enabled: true,
//     defaultUnSelect: true,
//     relatedCommodity: [
//       {
//         name: 'ONE_RS',
//         desc: 'ONE RS',
//         pid: 15,
//         enabled: true,
//         cids: [
//           1962, 1742, 1743, 1744, 1745, 1746, 1747, 1748, 1749, 1750, 1751, 1752, 1812, 2029, 2182, 2183, 2184, 2181,
//           2350, 2351, 2352, 2355, 2597,
//         ],
//       },
//     ],
//   },
//   ONE_RS_1_INCH: {
//     cid: 1851,
//     enabled: true,
//     defaultUnSelect: true,
//     relatedCommodity: [
//       {
//         name: 'ONE_RS_1_INCH',
//         desc: 'ONE_RS_1_INCH',
//         pid: 17,
//         enabled: true,
//         cids: [1918, 1919, 1921, 1923, 1920],
//       },
//       {
//         name: 'ONE_RS_1_INCH_Virtual_Tour',
//         desc: 'ONE_RS_1_INCH 海外房产',
//         pid: 21,
//         enabled: true,
//         cids: [1967, 2559, 2560, 2561, 2562, 2563, 2564, 2838],
//       },
//       {
//         name: 'real_estate_kit',
//         desc: 'real_estate_kit',
//         pid: 225,
//         enabled: true,
//         cids: [2206],
//       },
//       {
//         name: 'construction-kit', // 海外建筑套餐
//         desc: 'construction-kit',
//         pid: 23,
//         enabled: true,
//         cids: [2235],
//       },
//     ],
//   },
//   LINK: {
//     cid: 1973,
//     enabled: true,
//     defaultUnSelect: true,
//     relatedCommodity: [
//       {
//         name: 'LINK',
//         desc: 'LINK',
//         pid: 18,
//         enabled: true,
//         cids: [1980, 1981, 1982, 1983],
//       },
//     ],
//   },
//   X3: {
//     cid: 2119,
//     enabled: true,
//     defaultUnSelect: true,
//     relatedCommodity: [
//       {
//         name: 'X3',
//         desc: 'X3',
//         pid: 19,
//         enabled: true,
//         cids: [
//           2102, 2103, 2104, 2105, 2106, 2107, 2108, 2118, 2143, 2205, 2209, 2210, 2211, 2212, 2213, 2214, 2215, 2216,
//           2224, 2225, 2226, 2227, 2228, 2229, 2230, 2231, 2232, 2233, 2291, 2292, 2293, 2305, 2306, 2307, 2492, 2493,
//           2494, 2526, 2527, 2528, 2591, 2592, 2593, 2594, 2595, 2596, 2607, 2608, 2609, 2840, 2873, 2874, 2875, 2876,
//           2868, 2869, 2870, 2929, 2930, 2931,
//         ],
//       },
//       {
//         name: 'virtual_tour_kit', // 海外房产
//         desc: 'virtual_tour_kit',
//         pid: 21,
//         enabled: true,
//         cids: [2208, 2553, 2554, 2555, 2556, 2557, 2558, 2839, 3681, 3682],
//       },
//       {
//         name: 'Proptech-Labs-Virtual-Tour-Bundle',
//         desc: 'Proptech-Labs-Virtual-Tour-Bundle',
//         pid: 617,
//         enabled: true,
//         cids: [3688],
//       },
//       {
//         name: 'real_estate_kit', // 中国大陆看房
//         desc: 'real_estate_kit',
//         pid: 225,
//         enabled: true,
//         cids: [2207, 3681, 3682],
//       },
//       {
//         name: 'construction-kit', // 海外建筑套餐
//         desc: 'construction-kit',
//         pid: 23,
//         enabled: true,
//         cids: [2234, 3676],
//       },
//     ],
//   },
//   FLOW: {
//     cid: 2201,
//     enabled: true,
//     defaultUnSelect: true,
//     relatedCommodity: [
//       {
//         name: 'FLOW',
//         desc: 'FLOW',
//         pid: 22,
//         enabled: true,
//         cids: [2217, 2218, 2219, 2220, 2221, 2222],
//       },
//     ],
//   },
//   FLOW_Pro: {
//     cid: 3280,
//     enabled: true,
//     defaultUnSelect: true,
//     relatedCommodity: [
//       {
//         name: 'FLOW_Pro',
//         desc: 'FLOW Pro',
//         pid: 28,
//         enabled: true,
//         cids: [3272, 3273, 3274],
//       },
//     ],
//   },
// };

const getExtraIntro = ({ cid, LANG }) => {
  if (cid === 1757) return LANG['product.extraInfo.care_oneRS'];
};

export default {
  enabledCountry,
  getExtraIntro,
  enabledCountryMap,
};
